import { render, staticRenderFns } from "./EducationalQualification.vue?vue&type=template&id=8cadf9c0&"
import script from "./EducationalQualification.vue?vue&type=script&lang=js&"
export * from "./EducationalQualification.vue?vue&type=script&lang=js&"
import style0 from "./EducationalQualification.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports